import { useQuery } from '@tanstack/react-query'

import { GetMinimumGuaranteedCreditLimitResponse } from '@appTypes/EligibilityApi.interface'

import { SupportedQueryParameters } from '@utils/getAppStateFromQueryParameters'

import { handleApiResponse } from './utils/handleApiResponse'

export const useMinimumGuaranteedCreditLimitQuery = ({
    customerId,
}: {
    customerId: SupportedQueryParameters['customerId']
}) => {
    return useQuery<GetMinimumGuaranteedCreditLimitResponse>(
        ['minimumGuaranteedCreditLimit', customerId],
        () =>
            fetch(
                `${process.env.NEXT_PUBLIC_BASE_PATH}/api/minimum-guaranteed-credit-limit/?customerId=${customerId}`,
                {
                    method: 'GET',
                }
            ).then(handleApiResponse),
        {
            staleTime: Infinity,
            retry: false,
            refetchOnWindowFocus: false,
            retryOnMount: false,
            enabled: Boolean(customerId),
        }
    )
}
